export default "__VITE_ASSET__chz4$5LQ__"